import InvalidDataList from './InvalidDataList';

export const invalidDataPagesConfigs = [
  {
    path: '/invalid-data/all',
    element: <InvalidDataList />,
  },
];
